/*
 * @Author: shaozongyao
 * @Date: 2021-11-28 11:01:18
 * @LastEditTime: 2021-11-29 14:01:05
 * @LastEditors: your name
 */
import request from '../request'

export function fetchUserInfo (params = {}) {
  return request({
    url: '/app/user/get/target/userInfo',
    method: 'get',
    params
  })
}

export function getUserInfo () {
  return request({
    url: '/app/user/getUserInfo',
    method: 'post'
  })
}
